/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ProfileButtonQueryVariables = {
    id: string;
};
export type ProfileButtonQueryResponse = {
    readonly User_by_pk: {
        readonly id: string;
        readonly ProfilePhoto: {
            readonly id: unknown;
            readonly photoUrl: string;
        } | null;
    } | null;
};
export type ProfileButtonQuery = {
    readonly response: ProfileButtonQueryResponse;
    readonly variables: ProfileButtonQueryVariables;
};



/*
query ProfileButtonQuery(
  $id: String!
) {
  User_by_pk(id: $id) {
    id
    ProfilePhoto {
      id
      photoUrl
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "User_by_pk",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Photo",
        "kind": "LinkedField",
        "name": "ProfilePhoto",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "photoUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileButtonQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileButtonQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f1bef3c9585d0b945a6e4d6494a069c5",
    "id": null,
    "metadata": {},
    "name": "ProfileButtonQuery",
    "operationKind": "query",
    "text": "query ProfileButtonQuery(\n  $id: String!\n) {\n  User_by_pk(id: $id) {\n    id\n    ProfilePhoto {\n      id\n      photoUrl\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '62e2f2e201ff6b914a9361836601a442';
export default node;
